import React__default from 'react';
import OrderListItemCard from '../OrderListItemCard/OrderListItemCard.js';

const OrderListItem = ({ href , onClick , imageUrl , header , subtitle , labels  })=>{
    return /*#__PURE__*/ React__default.createElement(OrderListItemCard, {
        header: header,
        subtitle: subtitle,
        imagePath: imageUrl,
        href: href,
        onClick: onClick,
        labels: labels
    });
};
var OrderListItem$1 = OrderListItem;

export { OrderListItem$1 as default };
//# sourceMappingURL=OrderListItem.js.map
